module.exports = __webpack_public_path__ + "img/zanorari17.6ff845be.jpg";